import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";

export interface ConfigurationState {
  apiBaseUrl: string;
  token: string;
  agentId: string;
  tenantId: string;
}

const initialState: ConfigurationState = {
  apiBaseUrl: "",
  token: "",
  agentId: "",
  tenantId: "",
};

const configurationSlice = createSlice({
  name: "ctui-configuration",
  initialState,
  reducers: {
  },
});

export const selectAgentId = (state: RootState) => state["ctui-configuration"].agentId;
export default configurationSlice;
